import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Cta from "../components/CtaBranding";

import "../styles/common.css";
import "../styles/service.css";

import imgIssue01 from "../img/branding/illustration_branding_01.svg";
import imgIssue02 from "../img/branding/illustration_branding_02.svg";
import imgIssue03 from "../img/branding/illustration_branding_03.svg";
import imgfeature01 from "../img/branding/img_feature_01.png";
import imgfeature02 from "../img/branding/img_feature_02.png";
import imgfeature03 from "../img/branding/img_feature_03.png";
import imgfeature04 from "../img/branding/img_feature_04.png";

import { works, resolveWork } from "../data/works";
import { tagLabels } from "../data/tagLabels";

const lang = "ja";

const buildDisplayTags = (w) => {
  const industry = (w.industryTags ?? []).slice(0, 2);
  const companyCountry = w.company?.country ? [`companyCountry:${w.company.country}`] : [];
  return [...industry, ...companyCountry];
};

const Branding = () => {
  const resolvedWorks = works.map(resolveWork);

  const categories = ["Display", "Product", "Uniform", "Novelty", "SNS", "Character","Movie"];
  const brandingWorks = resolvedWorks
    .filter((w) => categories.includes(w.category))
    
  return (
    <>
      <Navbar></Navbar>
      <main className='branding'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>ブランディング支援</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">ブランディング支援</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className="title">
            <p className='title-lead'>ISSUE</p>
            <h2>このような課題を解決します</h2>
          </div>
          <div className='flexBox-bkWhite issue-box'>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue01} alt="" />
              </div>
              <h3>海外市場でのブランド認知を高めたいが、何から始めるべきかわからない</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue02} alt="" />
              </div>
              <h3>ブランドPRのためにワークショップを開催し、お客様の声を直接聞きたい</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue03} alt="" />
              </div>
              <h3>オウンドメディアやSNSを活用して、長期的なブランド価値を向上させたい</h3>
            </div>
          </div>
          <div className='issue-text'>
            <p>LOGOTは<br className='sp-only'/><span>企業の目指す未来</span>を<br /><span>ブランディングを通じて<br className='sp-only'/>サポート</span>します。</p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>ブランディング支援の4つの特長</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>越境ローカライズ支援 | 海外市場でのブランド強化</h3>
                <p className='feature-item__detail'>市場ごとに異なる文化や言語、ビジネス環境を考慮し、ブランドの価値を最適な形で海外市場に適応させます。<br />キックオフミーティングの段階から、ターゲット市場の消費者ニーズや競合状況を徹底的にリサーチ。<br />その結果をもとに、ターゲットに響く翻訳・コンテンツローカライズ・PR戦略を策定します。<br />単なる翻訳ではなく、文化的背景や言語特性を活かし、現地市場で共感を得られるブランド戦略をご提案します。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>長期的なブランド価値を創出</h3>
                <p className='feature-item__detail'>ブランドは一度作れば終わりではなく、継続的な発信と育成が必要です。<br />LOGOTでは、ブランド戦略をベースに、SNS・オウンドメディアを活用したコンテンツブランディングを支援。<br />投稿内容や写真でのイメージによるブランディング戦略を立案。</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>ブランドの「顔」を創る</h3>
                <p className='feature-item__detail'>ブランドの第一印象を決めるのは、視覚的なアイデンティティ。<br />LOGOTでは、キックオフミーティングから企業の理念やターゲットの心理を深く掘り下げ、市場調査を基にした戦略的なロゴデザイン・カラーパレット・フォントを提案します。<br />競合との差別化を図りながら、ブランドの世界観を視覚的に表現するデザイン設計を行い、企業の持つ価値を最大限に引き出す「ブランドの顔」を創り上げます。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature04} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>04</span></p>
                <h3>企業のブランド価値を伝える場を提供</h3>
                <p className='feature-item__detail'>ブランドの価値やメッセージは、体験を通じて深く浸透します。<br />LOGOTでは、企業が伝えたいブランドのストーリーをワークショップやブランディングイベントとして形にするお手伝いをします。<br />市場や競合の分析を踏まえ、ターゲットの関心や行動特性に合わせた企画・会場設計・運営をトータルプロデュース。</p>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='work-branding'>
          <div className='title'>
            <p className='title-lead'>WORK</p>
            <h2>制作実績</h2>
          </div>
          <div className="work-box">
  {brandingWorks.map((w) => {
    const displayTags = buildDisplayTags(w);

    return (
      <article key={w.slug}>
        <a href={`/work/${w.slug}`}>
          <div className="work-box__image">
            <img src={w.thumbnail} alt={w.title?.[lang] ?? ""} />
          </div>
          <div className="work-box__text">
            <h3>{w.title?.[lang]}</h3>

            {displayTags.length > 0 && (
              <ul className="work-box__tag">
                {displayTags.map((tag) => (
                  <li key={tag}>{tagLabels[tag]?.[lang] ?? tag}</li>
                ))}
              </ul>
            )}
          </div>
        </a>
      </article>
    );
  })}
</div>
        </section>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>ブランディング支援の流れ</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>事前準備・ヒアリング</h3>
                <p>LOGOTでは、プロジェクト開始前に、企業のブランド価値を最大限に引き出すためのビジョン・課題・目標を詳しくヒアリングします。<br />ターゲット市場・競合ブランド・企業の強みを分析し、最適なブランディング施策を決定するための準備を整えます。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>キックオフミーティング</h3>
                <p>ヒアリング結果をもとに、ブランドの世界観を明確に定義し、実施する施策ごとの戦略を設計します。<br />LOGOTでは、各施策（デザイン制作・ローカライズ支援・ワークショップ開催）の方針を決定し、受注内容に応じて進行します。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>ブランド価値を最大化する施策の展開</h3>
                <p>LOGOTのブランディング支援では、企業の目的に合わせ、必要な施策のみを実行可能です。<br />「ロゴデザインのみ」「ワークショップ開催のみ」などのご依頼にも対応できます。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>提出・ご報告</h3>
                <p>最終的な施策結果・提出物を共有いたします。<br />必要であれば効果をデータで分析し、ブランド認知度の変化・ターゲット市場でのエンゲージメントのご報告も可能です。</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='qa'>
          <div className="title">
            <p className='title-lead'>Q&A</p>
            <h2>よくある質問</h2>
          </div>
          <ul className='qa-box'>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>最低契約期間はありますか？</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>契約月から起算して、「6ヶ月間」の最低契約期間を設けています。</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>他社が制作したサイトでも契約可能ですか？</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>はい、対応可能です。ただし、当社が構築に関わっていないサイトの場合、仕様や設計の詳細が不明なため、一部対応が困難な場合がございます。あらかじめご了承ください。</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>ブランディング支援の具体的な内容を教えてください。</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>事前にお聞きしたお客様の課題をもとに、市場分析・アクセス分析を含む多角的な調査を行い、「今後のブランド運用方針」や「必要な施策・改修案」をご提案いたします。<br />また、海外市場での戦略設計だけでなく、実際の運用や施策実行までを見据えた戦術レベルの支援も提供し、お客様と伴走しながらブランド価値の向上をサポートします。</p></dd>
              </dl>
            </li>
          </ul>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Branding